export const PHOTO_DRAG_TYPE = 'application/x-uzd-query-photo';
export function movePhotoTags(tags, image, source, target, copy = false) {
  const selected = new Set((tags[image] || []).map(String));
  if (source && !copy) selected.delete(String(source));
  if (target) selected.add(String(target));
  if (selected.size > 10) throw new Error('A photo can show at most 10 parts.');
  return { ...tags, [image]: [...selected] };
}
export function projectionTags(projection) {
  return Object.fromEntries((projection?.photos || []).map(photo => [photo.image_id, photo.part_removed ? [] : (photo.query_part_ids || []).map(String)]));
}
